// 景點
export const GET_ATTRACTIONS = '/openApi/Attraction/GetOpenApiAttractions';
export const GET_ATTRACTION_DETAIL = '/openApi/Attraction/GetOpenApiAttractionDetail';

// 活動
export const GET_EVENTS = '/openApi/Event/GetOpenApiEvents';
export const GET_EVENT_DETAIL = '/openApi/Event/GetOpenApiEventDetail';

// 河川
export const GET_RIVERS = '/openApi/River/GetOpenApiRivers';
export const GET_RIVER_DETAIL = '/openApi/River/GetOpenApiRiverDetail';

// 分眾導覽
export const GET_TOUR_DETAIL = '/openApi/Tour/GetOpenApiTourDetail';

// 圖片
export const GET_PHOTO = '/photo';

// 共通性資料
export const GET_COMMON_MAPPINGS = '/api/Common/Mappings';

// Banner
export const GET_BANNERS = '/openApi/Banner/GetOpenApiBanners';

// 語音導覽
export const GET_AUDIO = '/audio/GetFile';

// 數位集章
export const GET_OPEN_API_COLLECTIONS = '/openApi/Collection/GetOpenApiCollections';
export const GET_OPEN_API_COLLECTION_DETAIL = '/openApi/Collection/GetOpenApiCollectionDetail';
export const POST_COLLECTION_SEND_GMAIL = '/Collection/SendGmail';

// QRCode
export const GET_OPEN_API_QRCODES = 'openApi/Qrcode/GetOpenApiQrcodes';

// 已過水API
export const PROXY_WRS_TAICHUNG = '/proxy/WrsTaichung';
export const PROXY_TOURISM_TAICHUNG = '/proxy/TourismTaichung';
